import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, computed, watch } from "@nuxtjs/composition-api";
import { toCurrencyFormat } from '~/core/helpers/GlobalHelpers';
import { useMobile } from "~/core/composables/useMobile";
import { UseExtraBalancesTypes } from "~/core/models/purchase-popup-2/UseExtraBalancesTypes";
import { UserBalance } from "~/core/models/purchase-popup-2/UserBalance";
import MunicipalityTx from "~/core/models/purchase-popup-2/MunicipalityTx";
import Web3MunicipalityTx from "~/core/models/purchase-popup-2/Web3MunicipalityTx";

interface Props {
    userBalance: UserBalance,
    transactionObject: MunicipalityTx | Web3MunicipalityTx,
    mustUseUtility: boolean,
    mustUseGymnet: boolean,
    activeAccount: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencySelection',
  props: {
    userBalance: null,
    transactionObject: null,
    mustUseUtility: { type: Boolean },
    mustUseGymnet: { type: Boolean },
    activeAccount: null
  },
  emits: ['onCurrencySelected', 'onClickBack', 'onStartLoading', 'onStopLoading'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { userBalance: UserBalance, transactionObject: MunicipalityTx | Web3MunicipalityTx, mustUseUtility: boolean, mustUseGymnet: boolean, activeAccount: string };





const {
    userBalance,
    transactionObject,
    mustUseUtility,
    mustUseGymnet,
    activeAccount,
} = toRefs(props);

const isMobile = useMobile();
const selectedExtraBalance = ref(null);
const useExtraBalances = ref(false);

const usdtAsset = computed(() => {
    switch (selectedExtraBalance.value) {
        case UseExtraBalancesTypes.BALANCE_GYMNET:
            return transactionObject.value.priceInfo.splitAmountGymnet.usdt;
        case UseExtraBalancesTypes.BALANCE_UTILITY:
            return transactionObject.value.priceInfo.splitAmountUtility.usdt;
        default:
            return transactionObject.value.priceInfo.totalAmount
    }
});

const extraBalanceAsset = computed(() => {
    switch (selectedExtraBalance.value) {
        case UseExtraBalancesTypes.BALANCE_GYMNET:
            return transactionObject.value.priceInfo.splitAmountGymnet.gymnet;
        case UseExtraBalancesTypes.BALANCE_UTILITY:
            return transactionObject.value.priceInfo.splitAmountUtility.gymnet;
    }
})

const utilityAsset = computed(() => transactionObject.value.priceInfo.splitAmountUtility.gymnet);
const gymnetAsset = computed(() => transactionObject.value.priceInfo.splitAmountGymnet.gymnet);
const isUtilityBalanceSufficient = computed(() => userBalance.value.utility.value >= utilityAsset.value.value);
const isGymnetBalanceSufficient = computed(() => userBalance.value.gymnet.value >= gymnetAsset.value.value);
const mustUseExtraBalancesValueUpdates = computed(() => `${mustUseUtility.value} - ${mustUseGymnet.value}`);

const onMustUseValueChange = () => {
    const canUseGymnetOrUtility = transactionObject.value.canUseGymnetOrUtility;
    if (
        canUseGymnetOrUtility &&
        (
            (mustUseUtility.value && isUtilityBalanceSufficient.value) ||
            (mustUseGymnet.value && isGymnetBalanceSufficient.value)
        )
    ) {
        useExtraBalances.value = true;
        handleExtraBalanceChange();
    }
}

const handleExtraBalanceChange = () => {
    if (useExtraBalances.value) {
        if (isUtilityBalanceSufficient.value && transactionObject.value.canUseUtility) {
            selectedExtraBalance.value = UseExtraBalancesTypes.BALANCE_UTILITY;
        } else if (isGymnetBalanceSufficient.value) {
            selectedExtraBalance.value = UseExtraBalancesTypes.BALANCE_GYMNET;
        }
    } else {
        selectedExtraBalance.value = null;
    }
}

const handleContinue = async () => {
    try {
        $emit('onStartLoading');
        transactionObject.value.setExtraBalance(selectedExtraBalance.value);
        const amountToCheck = usdtAsset.value.value;
        await transactionObject.value.checkAllowance(amountToCheck);

        if (transactionObject.value.isUsingExtraBalance &&
            transactionObject.value._isUsingExtraBalance === UseExtraBalancesTypes.BALANCE_GYMNET) {
            const gymnetAmountToCheck = transactionObject.value.priceInfo.splitAmountGymnet.gymnet.value;
            await transactionObject.value.checkGymnetAllowance(gymnetAmountToCheck);
        }
        $emit('onCurrencySelected');
        $emit('onStopLoading');
    } catch (e) {
        $emit('onStopLoading', e);
    }
}

watch(
    mustUseExtraBalancesValueUpdates,
    onMustUseValueChange,
    { immediate: true }
);

watch(
    activeAccount,
    onMustUseValueChange,
    { immediate: true },
)


return { __sfc: true,props, $emit, userBalance, transactionObject, mustUseUtility, mustUseGymnet, activeAccount, isMobile, selectedExtraBalance, useExtraBalances, usdtAsset, extraBalanceAsset, utilityAsset, gymnetAsset, isUtilityBalanceSufficient, isGymnetBalanceSufficient, mustUseExtraBalancesValueUpdates, onMustUseValueChange, handleExtraBalanceChange, handleContinue, toCurrencyFormat, UseExtraBalancesTypes }
}

})